export default __webpack_public_path__ + "static/media/prize-draw-benefit.32963c33.svg";